export default {
    prevText: '上一页',
    nextText: '下一页'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/pagination/locale/zh_CN.js
// module id = 230
// module chunks = 0